export const ONBOARDING_V1_URL = '/v1/dasher-onboarding'
export const ONBOARDING_V2_URL = '/v2/dasher-onboarding'
export const DD_DXO_ENV_KEY = 'dd_dxo_env'

export enum DASHER_MOBILE_BFF_ENV_URL {
  PRODUCTION = 'https://dasher-mobile-bff.doordash.com/',
  STAGING = 'https://dasher-mobile-bff.doorcrawl.com/',
  PROXY = 'http://localhost:8081/mobileBff/',
}
